export default __webpack_public_path__ + "media/69b2dbe9cef44c66db3761e0ae26bc100648ea096e5f38e296d5b76ae10a6e37.svg";